import * as actions from './orders.actions'

export const isSilent = (payload: string | void | actions.FetchOrdersRequestPayload) => {
  return typeof payload === 'object' && 'silent' in payload && payload.silent
}
